/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2019, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { all, call, put, takeEvery } from 'redux-saga/effects';

import * as api from '@ibm-watson/shared/modules/ia/api/plan';
import { setAccount } from '@ibm-watson/shared/modules/ia/store/session/actions';
import { getErrorString } from '@ibm-watson/shared/modules/ia/util/errorHandler';
import { ctaEvents } from '@ibm-watson/shared/modules/ia/util/trackers/segment';
import * as actions from './actions';
import * as actionType from './actionTypes';

export function* upgradePlan(action) {
  try {
    yield call(
      api.upgradePlan,
      action.region,
      action.instance,
      action.upgradingPlanName
    );
    yield put(actions.upgradePlanSuccess(action.upgradingPlanName));
    ctaEvents.upgradePlan({
      category: action.upgradingPlanName,
      successFlag: true,
      resultValue: 'success'
    });
  } catch (error) {
    yield put(actions.upgradePlanError(error));
    ctaEvents.upgradePlan({
      category: action.upgradingPlanName,
      successFlag: false,
      resultValue: getErrorString(error) || error
    });
  }
}

function* watchUpgradePlan() {
  yield takeEvery(actionType.UPGRADE_PLAN_START, upgradePlan);
}

export function* getAccountType(action) {
  try {
    const accountDetail = yield call(api.getAccountDetail, action.accountId);
    yield put(setAccount(accountDetail));
    yield put(actions.accountTypeSuccess(accountDetail.type));
  } catch (error) {
    yield put(actions.accountTypeError(error));
  }
}

function* watchGetAccountType() {
  yield takeEvery(actionType.GET_ACCOUNT_TYPE, getAccountType);
}

export function* loadApiUsage(action) {
  try {
    const apiUsage = yield call(api.getAccountUsage, action.accountId);
    yield put(actions.apiUsageSuccess(apiUsage.api));
  } catch (error) {
    // Errors here can be ignored - just means we record no API usage data
  }
}

function* watchLoadApiUsage() {
  yield takeEvery(actionType.LOAD_API_USAGE, loadApiUsage);
}

export default function* rootSaga() {
  yield all([watchUpgradePlan(), watchGetAccountType(), watchLoadApiUsage()]);
}
